import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Store, select } from "@ngrx/store";
import { map, take } from 'rxjs/operators';
import * as ClientActions from '@core/state/client/client.actions';
import * as fromClient from '@core/state/client/client.selectors';
import { Observable } from "rxjs";
import { SessionService } from "@core/services/session/session.service";
import { Client } from "@core/models/client";

@Injectable({
    providedIn: 'root'
})

export class AvalaraCustomerResolver  {
    avalaraCustomerId: string;
    client?: Client;

    constructor(
        private store: Store,
        private sessionService: SessionService
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        this.client = this.sessionService.getActiveClient();
        this.store.dispatch(ClientActions.getAvalaraClient({ customerCode: this.client?.id}))

        return this.store.pipe(
            select(fromClient.selectAvalaraClient),
            take(1),
            map(() => true)
        )
    }
}
